<dms-loading [loading]="loading"></dms-loading>
<router-outlet (activate)="changeOfRoutes()"></router-outlet>

<dms-confirm></dms-confirm>
<ng-container *ngIf="_shortcutService.showTercerosModal || _shortcutService.showVehiculosModal">
    <dms-modal-generico (onCloseClick)="_shortcutService.closeTercerosVehiculosModal()">
        <div modal-title></div>
        <div modal-content style="width: 1000px!important">
            <ng-container *ngIf="_shortcutService.showTercerosModal">
                <app-gestion-terceros-register [cargarVista]="'gestionTerceros'" [isModal]="true"></app-gestion-terceros-register>
            </ng-container>
            <ng-container *ngIf="_shortcutService.showVehiculosModal">
                <dms-gestion-form [tab]="0" [transmitter]="'gestionVehiculos'" [formMode]="_authService.getUserRole()" [isModal]="true"></dms-gestion-form>
            </ng-container>
        </div>
    </dms-modal-generico>
</ng-container>

